import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {
  Button,
  spacing,
  fontSize,
  colors,
  borderRadius,
  FormField,
  PageLayoutContent,
} from '@retailer-platform/shared-components'
import { spacing as idsSpacing } from '@instacart/ids-core'

export const StyledInputFieldInfo = styled.div({
  display: 'flex',
  flexDirection: 'row',
  background: colors.GRAYSCALE.X10,
  padding: spacing.X12,
  paddingTop: spacing.X24,
  fontSize: fontSize.X12,
  color: colors.GRAYSCALE.X70,
  marginTop: `-${spacing.X36}`,
  marginBottom: `${spacing.X12}`,
  borderRadius: borderRadius.X8,
  alignItems: 'center',

  '& svg': {
    marginRight: spacing.X8,
    width: 12,
    height: 12,
    verticalAlign: 'bottom',
  },
})

export const buttonStyles = css({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',

  '& .button-label + *': {
    marginLeft: spacing.X12,
  },
})

export const StyledLoadingDots = styled.div({
  fontSize: 0,
})

export const sectionStyles = css({
  margin: `${idsSpacing.s24}px ${idsSpacing.s48}px`,
})

export const FieldRow = styled.div({
  display: 'flex',
  flexDirection: 'row',
  columnGap: spacing.X32,
})

export const FormFieldBottom = styled(FormField)({
  paddingBottom: 0,
})

export const StyledAccountForm = styled.form({
  flexGrow: 1,
  overflow: 'hidden',
})

export const StyledPageLayoutContent = styled(PageLayoutContent)(({ theme }) => ({
  backgroundColor: theme.colors.systemGrayscale10,
}))

export const FormActionsFooter = styled.div({
  marginLeft: 'auto',
  marginRight: spacing.X24,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: spacing.X24,
})

export const StyledButton = styled(Button)({
  marginLeft: 0,
  marginRight: 0,
})

interface FullAccessSectionProps {
  disabled?: boolean
}

export const FullAccessSection = styled.div<FullAccessSectionProps>(({ theme, disabled }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: spacing.X12,
  color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70,
  ...theme.typography.bodyMedium1,
}))

interface FormFieldLabelProps {
  disabled?: boolean
}

export const FormFieldLabel = styled.label<FormFieldLabelProps>(({ theme, disabled }) => ({
  color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70,
  ...theme.typography.bodyMedium1,
}))

interface CreateAnotherContainerProps {
  disabled?: boolean
}

export const CreateAnotherContainer = styled.div<CreateAnotherContainerProps>(
  ({ disabled, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: spacing.X8,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70,
    ...theme.typography.bodySmall2,
  })
)
